export const allVrTypes = [
  { value: "GO", label: "Oculus Go" },
  { value: "DAYDREAM", label: "Daydream" },
  { value: "GEARVR", label: "Gear VR" },
  { value: "QUEST", label: "Oculus Quest" },
  { value: "FOCUS", label: "Focus" },
  { value: "PICO", Label: "Pico" },
  { value: "UNKNOWN", label: "Unknown" },
];
